import { Component } from '@angular/core';
import { CoreServices, FlexusStateBase } from 'flx-engine';
import { ActivatedRoute } from '@angular/router';


@Component({
    selector: 'workflow-state',
    template: `
    <router-outlet></router-outlet>
    `,
    styleUrls: ['workflow-state.component.scss']
})
export class WorkflowStateComponent extends FlexusStateBase {
    constructor(svc: CoreServices, route: ActivatedRoute) {
        super(svc, route);
    }
}
